<template>
  <div>
    <Breadcrumbs main="Dashboard" title="Dashboard" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
     <div class="row">
       <div class="xl-50 col-md-6">

            <section class="item-asessment">
              <div class="card">
                <div class="card-header">
                  <img
                      class="user-img"
                      :src="`https://redwhiteanalytics.com/images/assesment/personality.png`"
                      alt=""
                    />
                </div>
                <div class="card-body">
                  <h5>{{ $t('kelengkapan') }} : {{ persenComplateProfile }}%</h5>

                  <b-progress class="mb-2" height="11px" variant="primary" :value="countComplateProfile" :max="6"></b-progress>
                  <p>
                    <strong>{{ $t('info_kelengkapan_profile') }}</strong>
                    <!-- <br> {{ $t('yuk_lengkapi') }} -->
                  </p>

                  <b-list-group tag="ul">
                      <b-list-group-item tag="li" class="d-flex justify-content-between align-items-center">{{ $t('informasi_dasar') }} <b-badge :variant="data.profile.basic_informations > 0 ? 'success' : 'danger' " class="counter digits"> {{ data.profile.basic_informations > 0 ? $t('lengkap') : $t('belum_lengkap') }}</b-badge></b-list-group-item>
                      <b-list-group-item tag="li" class="d-flex justify-content-between align-items-center">{{ $t('riwayat_pendidikan') }} <b-badge :variant="data.profile.education_histories > 0 ? 'success' : 'danger' " class="counter digits">{{ data.profile.education_histories > 0 ? $t('lengkap') : $t('belum_lengkap') }}</b-badge> </b-list-group-item>
                      <b-list-group-item tag="li" class="d-flex justify-content-between align-items-center">{{ $t('sertifikat_pelatihan') }} <b-badge :variant="data.profile.certifications > 0 ? 'success' : 'danger' " class="counter digits">{{ data.profile.certifications > 0 ? $t('lengkap') : $t('belum_lengkap') }}</b-badge> </b-list-group-item>
                      <b-list-group-item tag="li" class="d-flex justify-content-between align-items-center">{{ $t('penglaman_kerja') }}<b-badge :variant="data.profile.work_experiences > 0 ? 'success' : 'danger' " class="counter digits">{{ data.profile.work_experiences > 0 ? $t('lengkap') : $t('belum_lengkap') }}</b-badge> </b-list-group-item>
                      <b-list-group-item tag="li" class="d-flex justify-content-between align-items-center">{{ $t('daftar_penghargaan') }} <b-badge :variant="data.profile.achievements > 0 ? 'success' : 'danger' " class="counter digits">{{ data.profile.achievements > 0 ? $t('lengkap') : $t('belum_lengkap') }}</b-badge> </b-list-group-item>
                      <b-list-group-item tag="li" class="d-flex justify-content-between align-items-center">Softskill & Hardskill <b-badge :variant="data.profile.softskill > 0 ? 'success' : 'danger' " class="counter digits">{{ data.profile.softskill > 0 ? $t('lengkap') : $t('belum_lengkap') }}</b-badge> </b-list-group-item>
                  </b-list-group>

                  <button class="btn btn-primary btn-sm mt-4" @click="$router.push({
                    path : '/candidate/profile'
                  })">{{ $t('buka_profile') }}</button>
                </div>
              </div>
            </section>
        </div>


       <div class="xl-50 col-md-6">

            <section class="item-asessment">
              <div class="card">
                <div class="card-header">
                  <img
                      class="user-img"
                      :src="`https://redwhiteanalytics.com/images/tade/target.svg`"
                      alt=""
                    />
                </div>
                <div class="card-body">
                  <h5>{{ $t('tugas_asessment') }}</h5>
                  <p>
                    {{ $t('desc_asessment') }}
                  </p>
                  <b-progress class="mb-2" height="11px" variant="primary" :value="countAsessmentDone" :max="6"></b-progress>
                  <span class="d-block text-center mb-3">{{ countAsessmentDone }} / {{ count_asessment }} {{ $t('asessment_selesai') }}</span>

                  <button class="btn btn-primary btn-sm mt-4" @click="$router.push({
                    path : '/candidate/asessment'
                  })">{{ $t('buka_asessment') }}</button>
                </div>
              </div>
            </section>
        </div>
     </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import { getAsessment } from '../../_services/asessment.service';
import { getDataCheckComplete } from '../../_services/data.service';
import * as Cookies from 'js-cookie';

  // var secondary = localStorage.getItem('secondary_color') || '#f73164';

  export default {
    data() {
      return {
        dataHeader: {
          total_candidate : 0,
          total_registration: 0,
          total_inprogress: 0,
          total_finish: 0
        },
        data : {},
        countComplateProfile: 0,
        countAsessmentDone: 0,
        persenComplateProfile: 0,
        count_asessment: 0,
      };
    },
    async mounted() {
      if (this.$route.query && !localStorage.getItem('x-access-token')) {
        if(this.$route.query.token){
          localStorage.setItem('x-access-token',this.$route.query.token);
        }
      }
      
      this.getDataHeader();
      this.getDataComplete();
      let c_asess = localStorage.getItem('count_asessment');
        if (!c_asess) {
          let data = await getAsessment();
          localStorage.setItem('count_asessment', data.data.length);
          this.count_asessment = data.data.length;
        }else{
          this.count_asessment = c_asess;
        }
    },
    methods : {
      
      async getDataHeader() {
        let data_header = await this.$store.dispatch("match_scoring/getDataHeader");
        this.dataHeader = data_header;
      },
      async getDataComplete(){

        let data_res = await getDataCheckComplete();
        this.data = data_res.data;

        let data_profile = data_res.data.profile;
        this.countComplateProfile =
          // data_profile.about +
          data_profile.achievements +
          data_profile.basic_informations +
          data_profile.certifications +
          data_profile.education_histories +
          data_profile.work_experiences +
          data_profile.softskill ;

        this.persenComplateProfile = Number((this.countComplateProfile / 6) * 100).toFixed(0);


        let asessment = data_res.data.asessment;
        var count = 0;
        for (const key in asessment) {
          if (Object.hasOwnProperty.call(asessment, key)) {
            const element = asessment[key];
            if(element > 0){
              count++;
            }

          }
        }
        this.countAsessmentDone = count;

        localStorage.setItem('profile_complate', this.countComplateProfile);
        localStorage.setItem('asessment_complate', this.countAsessmentDone);
      },
      
    },
  };
</script>
<style lang="scss">
.item-asessment{
  .card-header{
    padding: 0!important;
    img{
      width: 100%;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      max-height: 150px;
      background-size: cover;
      object-fit: contain;
      margin: 2rem 0;
    }
  }

  .card-body{
    text-align: center;
    padding: 1.2rem 1.7rem!important;
    h3,p{
      text-align: center;
    }
    p{
      font-size: .9rem;
    }
    .progress{
      margin: 0 2rem;
      border-radius: 1rem;
      .progress-bar{
        border-radius: 1rem;
      }
    }
    .btn-primary{
      border-radius: .3rem;
      font-family: 'Rubik';
      font-size: .8rem;
      font-weight: 600!important;
    }
  }
}
</style>